import { SharedModel } from './SharedModel';

export const ContractItems = ['Ball', 'Shoe', 'Glove', 'Driver', 'Irons', 'Wedges', 'Putter', 'Headwear', 'Bag', 'Headcovers', 'Umbrella', 'Rainwear', 'Club Glove', 'Apparel'];

export interface ContractUser {
  appUserId: number;
  aspNetUserGuid: string;
  fullName: string;
  email: string;
}

export interface Contract extends SharedModel {
  startDate: string;
  endDate: string;
  // only used when calling getPlayersWithTourAndBioV2:
  status: string; //active, expired, no contract
  items: Array<string>;
}

export interface CurrentContract extends Contract {
  modifiedByUser: ContractUser;
  createdByUser: ContractUser;
}

export interface ContractHistory extends CurrentContract {
  snapshotId: number;
  snapshotCreatedAt: string;
}

export interface ContractsHistory {
  ContractHistory: Array<ContractHistory>;
}

export interface PlayerContractHistory {
  playerId: number;
  currentContract: CurrentContract;
  contractsHistory: ContractHistory[];
}

export interface ContractHistoryDiff {
  fullName: string;
  snapshotCreatedAt: string;
  startDate: string;
  endDate: string;
  itemsAdded: string[];
  itemsRemoved: string[];
}
